var config = {
   manifestPath: 'https://live.stateofgreen.com/green-together/assets/json/en/manifest.json',
   tempMediaPath: 'https://sogumbraco.azurewebsites.net/output/green-together/',
   umbracoMediaPath: 'https://live.stateofgreen.com',
}

if (window.location.hostname === "sogumbraco.azurewebsites.net" )
{
  config.tempMediaPath = '';
    config.manifestPath = 'https://sogumbraco.azurewebsites.net/output/green-together/assets/json/en/manifest.json';
    config.umbracoMediaPath = 'https://sogumbraco.azurewebsites.net';
    }

export default config;